import request from "@/utils/request.js";
class Api {
  // 首页-实时统计数据
  list(params) {
    return request({
      method: "get",
      url: "/task/list",
      params,
    });
  }
  editStatus(data) {
    return request({
      method: "post",
      url: "/task/status",
      data,
    });
  }
  assignTasks(data) {
    return request({
      method: "post",
      url: "/task/assign",
      data,
    });
  }
  configList() {
    return request({
      method: "get",
      url: "/task/config/list",
    });
  }
  configAdd(data) {
    return request({
      method: "post",
      url: "/task/config/add",
      data,
    });
  }
  configEdit(data) {
    return request({
      method: "post",
      url: "/task/config/edit",
      data,
    });
  }
  configDel(data) {
    return request({
      method: "post",
      url: "/task/config/del",
      data,
    });
  }
  autoAssign() {
    return request({
      method: "post",
      url: "/task/auto_assign",
    });
  }
}
export default new Api();
